<div class="sv-wrap">

    <!-- Header -->
    <div class="sv-header">
        <span class="sv-header-title">{{ title }}</span>
        <button mat-icon-button (click)="close()" class="sv-close-btn">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Scrollable Body -->
    <div class="sv-body" [formGroup]="siteVisitForm">

        <!-- Title -->
        <div class="sv-field-box sv-field-box--tall">
            <label class="sv-label">Title <span class="sv-required">*</span></label>
            <input class="sv-input" formControlName="title"
                placeholder="Site Visit Title  e.g. Property Inspection at Green Villa" />
            <div class="sv-error"
                *ngIf="siteVisitForm.controls['title'].touched && siteVisitForm.controls['title'].errors?.['required']">
                Title is required
            </div>
        </div>

        <!-- Description / Notes -->
        <div class="sv-field-box">
            <label class="sv-label">Description / Notes</label>
            <textarea class="sv-input sv-textarea" formControlName="description" rows="4"
                placeholder="Enter visit objective or customer requirements..."></textarea>
        </div>

        <!-- Visit Status -->
        <div class="sv-field-box">
            <label class="sv-label">Visit Status</label>
            <div class="sv-select-wrap">
                <select class="sv-select" formControlName="visitStatus">
                    <option value="" disabled hidden>Select status...</option>
                    <option *ngFor="let s of statusList" [value]="s.value">{{ s.viewValue }}</option>
                </select>
                <mat-icon class="sv-select-arrow">keyboard_arrow_down</mat-icon>
            </div>
        </div>

        <!-- Start Date / Start Time -->
        <div class="sv-field-row">
            <div class="sv-field-box">
                <label class="sv-label">Start Date</label>
                <div class="sv-date-wrap">
                    <input class="sv-input" [min]="minDate" [matDatepicker]="startPicker"
                        formControlName="startDateTime" required readonly placeholder="Start Date" />
                    <mat-icon class="sv-date-icon" (click)="startPicker.open()">calendar_today</mat-icon>
                    <mat-datepicker #startPicker></mat-datepicker>
                </div>
            </div>

            <div class="sv-field-box">
                <label class="sv-label">Start Time <span class="sv-required">*</span></label>
                <div class="sv-date-wrap">
                    <input class="sv-input" type="time" formControlName="startTime" required #startTimeInput
                        placeholder="--:--" />
                    <!-- <mat-icon class="sv-date-icon"
                        (click)="startTimeInput.showPicker()">schedule</mat-icon> -->
                </div>
                <div class="sv-error"
                    *ngIf="siteVisitForm.controls['startTime'].touched && siteVisitForm.controls['startTime'].errors?.['required']">
                    Start Time is required
                </div>
            </div>
        </div>

        <!-- End Date / End Time -->
        <div class="sv-field-row">
            <div class="sv-field-box">
                <label class="sv-label">End Date</label>
                <div class="sv-date-wrap">
                    <input class="sv-input" [min]="minDate" [matDatepicker]="endPicker" formControlName="endDateTime"
                        required readonly placeholder="End Date" />
                    <mat-icon class="sv-date-icon" (click)="endPicker.open()">calendar_today</mat-icon>
                    <mat-datepicker #endPicker></mat-datepicker>
                </div>
            </div>

            <div class="sv-field-box">
                <label class="sv-label">End Time <span class="sv-required">*</span></label>
                <div class="sv-date-wrap">
                    <input class="sv-input" type="time" formControlName="endTime" required #endTimeInput
                        placeholder="--:--" />
                    <!-- <mat-icon class="sv-date-icon"
                        (click)="endTimeInput.showPicker()">schedule</mat-icon> -->
                </div>
                <div class="sv-error"
                    *ngIf="siteVisitForm.controls['endTime'].touched && siteVisitForm.controls['endTime'].errors?.['required']">
                    End Time is required
                </div>
            </div>
        </div>

        <!-- Time Zone -->
        <div class="sv-field-box">
            <label class="sv-label">Time Zone</label>
            <div class="sv-select-wrap">
                <select class="sv-select" formControlName="timeZone">
                    <option value="" disabled hidden>Select timezone...</option>
                    <option *ngFor="let tz of zone" [value]="tz.value">{{ tz.label }}</option>
                </select>
                <mat-icon class="sv-select-arrow">keyboard_arrow_down</mat-icon>
            </div>
        </div>

        <!-- Property Name -->
        <div class="sv-field-box">
            <label class="sv-label">Property Name</label>
            <mat-form-field appearance="outline" class="sv-chip-form-field">
                <mat-chip-list #chipList>
                    <mat-chip *ngFor="let item of selectedProperties" [removable]="true"
                        (removed)="removeProperty(item)">
                        {{ item.propertyName || item.name }}
                        <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                    <input *ngIf="selectedProperties.length === 0" #propertyInput type="text"
                        placeholder="Search Property" (input)="onPropertyInput($event)" matInput
                        [formControl]="propertyCtrl" [matAutocomplete]="auto1" [matChipInputFor]="chipList"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" />
                </mat-chip-list>
                <mat-autocomplete #auto1="matAutocomplete"
                    (optionSelected)="onPropertyOptionSelected($event.option.value)">
                    <mat-option *ngFor="let option of filteredPropertyList" [value]="option">
                        {{ option.propertyName || option.name }}
                    </mat-option>
                    <mat-option
                        *ngIf="(propertyCtrl.value || '').toString().trim().length > 0 && (!filteredPropertyList || filteredPropertyList.length === 0)"
                        disabled>
                        No results found
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>

    </div>

    <!-- Footer -->
    <div class="sv-footer">
        <button (click)="close()" class="sv-btn sv-btn-cancel">Cancel</button>
        <button [disabled]="isSaving" (click)="saveSiteVisit()" class="sv-btn sv-btn-save">
            <mat-spinner *ngIf="isSaving" diameter="16" style="display:inline-block;margin-right:6px;"></mat-spinner>
            {{ isSaving ? 'Saving...' : 'Save' }}
        </button>
    </div>

</div>